<div class="modal">
  <div class="modal-content" role="dialog" aria-modal="true" aria-labelledby="location-mismatch-modal-header" aria-describedby="location-mismatch-modal-message" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
    <div class="modal-body">
      <p class="header-text" id="location-mismatch-modal-header">{{'talent-happy-path.quick-apply.submit-page.location-mismatch.modal-header' | translate}}</p>
      <p class="body-text" id="location-mismatch-modal-message">{{'talent-happy-path.quick-apply.submit-page.location-mismatch.modal-message' | translate}}</p>
    </div>
    <div class="modal-footer">
      <a mat-button [href]="jobBoardUrl" class="modal-button" id="location-mismatch-search-jobs">{{'talent-happy-path.quick-apply.submit-page.location-mismatch.search-jobs' | translate}}</a>
      <button mat-button class="modal-button" (click)="onContinue()" id="location-mismatch-continue">{{'talent-happy-path.quick-apply.submit-page.location-mismatch.continue' | translate}}</button>
    </div>
  </div>
</div>
